import { render, staticRenderFns } from "./DeletedIndex.vue?vue&type=template&id=69f0d0da&"
import script from "./DeletedIndex.vue?vue&type=script&lang=js&"
export * from "./DeletedIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports